import React from "react";
import {registerBlockType} from "@wordpress/blocks";
import { Fragment } from "@wordpress/element";
import {RichText} from "@wordpress/block-editor";
import PMGColorPalette,{fontColorAssociations} from "./PMGColorPalette";

import {PanelBody,Panel,RangeControl,SelectControl,CheckboxControl,TextControl,Button} from "@wordpress/components";
import {
    useBlockProps,
    ColorPalette,
    InspectorControls,
    InnerBlocks,
    BlockControls,
    AlignmentToolbar,
    MediaUpload,
    MediaUploadCheck,
    __experimentalLinkControl as LinkControl
} from '@wordpress/block-editor';

registerBlockType("template-scripts/airport-map", {
  title: "Airport Map",
  category: "template-scripts",
  icon: "button",
  attributes: {
    hideBG:{type:'boolean',default:false},
    parallaxScroll:{type:'boolean',default:false},
    minimalList:{type:'boolean',default:false},
    backgroundColor:{type:'string',default:'#2b87c3'},
    maxWidth:{type:'number',default:1250},
    // Add any attributes you need here
  },
  edit: function({attributes, setAttributes}) {
    return (<>
    <InspectorControls>
      <Panel>
        <PanelBody title="Background">
          <CheckboxControl
            label="Hide Background"
            checked={attributes.hideBG}
            onChange={(v)=>setAttributes({hideBG:v})}
          />
          <PMGColorPalette
            value={attributes.backgroundColor}
            onChange={(v)=>setAttributes({backgroundColor:v})}
          />
          <RangeControl
            label="Max Width"
            value={attributes.maxWidth}
            onChange={(v)=>setAttributes({maxWidth:v})}
            min={100}
            max={1600}
            step={1}
          />
          <CheckboxControl
            label="Parallax Scroll"
            checked={attributes.parallaxScroll}
            onChange={(v)=>setAttributes({parallaxScroll:v})}
          />
          <CheckboxControl
            label="Minimal List"
            checked={attributes.minimalList}
            onChange={(v)=>setAttributes({minimalList:v})}
          />
        
        </PanelBody>
      </Panel> 
    </InspectorControls>
      <div {...useBlockProps()} style={{display:"flex",width:"100%",maxWidth:"100% !important",justifyContent:"center",alignItems:"center",height:"200px",border:"1px dashed #666",backgroundColor:attributes.backgroundColor || "#ececec"}}>
        <BlockControls>
          
        </BlockControls>
        AIRPORT MAP GOES HERE
      </div>
    </>);
  },
  save: function({attributes}) {
    return null;
  }
});
